// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__1fnSi","dark":"Rating_dark__buvgd","medium":"Rating_medium__DroIg","fadeIn":"Rating_fadeIn__3c99P","scaleXin":"Rating_scaleXin__30HVm"};